exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".systemMessagesFilterForm__form___jgotW {\n  padding: 8px 12px;\n  border-left: 1px solid #e8e8e8;\n  border-right: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n  width: 100%; }\n\n.systemMessagesFilterForm__actionButton___rHTXI {\n  height: 54px;\n  width: 100% !important; }\n\n.systemMessagesFilterForm__gutterBox___231kd {\n  padding-left: 2.5px;\n  padding-right: 2.5px;\n  margin-bottom: 10px; }\n  .systemMessagesFilterForm__gutterBox___231kd .ant-calendar-picker {\n    width: 100%; }\n  .systemMessagesFilterForm__gutterBox___231kd .ant-calendar-picker-input {\n    height: 54px; }\n\n.systemMessagesFilterForm__fullWidth___2uHNE {\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"form": "systemMessagesFilterForm__form___jgotW",
	"actionButton": "systemMessagesFilterForm__actionButton___rHTXI",
	"gutterBox": "systemMessagesFilterForm__gutterBox___231kd",
	"fullWidth": "systemMessagesFilterForm__fullWidth___2uHNE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageSystemMessagesPage/systemMessagesFilterForm.scss
// module id = 4089
// module chunks = 6